import { Injectable } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { EMPTY, Observable, of, take, tap } from 'rxjs';
import { SvcDialogService } from './svc-dialog.service';

@Injectable({
  providedIn: 'root',
})
export class SvcDialogRefResolver {
  private dialogRef: MatDialogRef<any>;

  constructor(
    public _dialog: SvcDialogService,
    private router: Router
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<MatDialogRef<any>> | Observable<any> {
    const id = route.paramMap.get('id'); // Captura o parâmetro 'id' da rota

    // Verifica se o 'id' é um número válido
    if (id && !isNaN(+id)) {
      const data = route.data;
      this.dialogRef = this._dialog.open(route.routeConfig.component, {
        ...data,
        data: { ...data.dialog, id }, // Passa o 'id' como parte dos dados do modal
        closeOnNavigation: true,
        size: data.size,
      });

      // Redireciona para rota default quando o modal é fechado.
      this.dialogRef.afterClosed().subscribe(() => {
        this.router.navigate(['']);
      });

      return of(this.dialogRef);
    } else {
      this.router.navigate(['']); // Redireciona para uma rota default
      return EMPTY; // Retorna um Observable vazio
    }
  }
}
